import React from "react";
import PropTypes from "prop-types";
import classes from "./link.module.scss";
import { NavLink } from "react-router-dom";

const Item = (props) => {
  return (
    <NavLink exact to={props.to} className={classes.link}>
      {props.inner}
    </NavLink>
  );
};

Item.propTypes = {
  to: PropTypes.string,
  inner: PropTypes.any,
};

export default Item;
